// extracted by mini-css-extract-plugin
module.exports = {"AboutMe":"AboutMe_AboutMe__122Ga","anim":"AboutMe_anim__fZbmW","robotAnim":"AboutMe_robotAnim__3-ZD5"};